export const DEV_MOCK_TEST_EDIT_KEY = '9999999999999999';
export const DEV_MOCK_DOCS_FLAG = true;
export const DEV_MOCK_DISMISS_PREFIX = 'nkr.watr.devMockDocs.dismiss.';

export type DevMockKind = 'paystub' | 'tax' | 'ssn' | 'receipt';
export type DevMockCategory = 'Wage' | 'Expense';
export type DevMockBatchType = 'clean' | 'mixed' | 'challenging';

export const DEV_MOCK_BATCH_OPTIONS: Array<{
    id: DevMockBatchType;
    label: string;
    description: string;
}> = [
    {
        id: 'clean',
        label: 'Clean',
        description: 'Clear scans. Values match the open request (name, SSN, tax year, amounts).'
    },
    {
        id: 'mixed',
        label: 'Mixed',
        description: 'Most files match the request; a few intentionally use off values so Locate / verify can miss.'
    },
    {
        id: 'challenging',
        label: 'Challenging',
        description: 'Harder-to-read scans plus more mismatched values for OCR and approval edge cases.'
    }
];


export interface DevMockSlot {
    key: string;
    docType: number;
    lookupId: number;
    label: string;
    kind: DevMockKind;
    category: DevMockCategory;
    detail?: string;
    secondary?: string;
}

export interface DevMockReceiptInput {
    fileId: number;
    expenseType?: number;
    expenseTypeName?: string;
    amount?: number;
    description?: string;
    tripName?: string;
    expenseDate?: string;
    receiptFileName?: string;
}
